import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Item, Input, Button, Icon, Table, Select, DatePicker, Radio, Row } from 'antd';
import { createShowEditAction, modifySelf, getList } from '../../actions/user';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};
/**
 * 弹窗组件
 */
class Edit extends React.Component {
    constructor(props) {
        super(props);
    }
    // 提交编辑
    async modifyUser() {
        this.props.form.validateFields(async (err, fieldsValue) => {
            if (!err) {
                try {
                    console.log(fieldsValue);
                    await this.props.modifySelf(fieldsValue);
                    await this.props.form.resetFields();
                } catch (err) {
                    alert(err);
                }
            } else {
                console.log(err);
            }
        });
    };
    render() {
        const { modifySelf } = this.props;
        const { getFieldDecorator, validateFields, resetFields } = this.props.form;

        return (
            <Form style={{ textAlign: 'center', marginTop: '200px' }}>
                <Row style={{ textAlign: 'center' }}>
                    <FormItem style={{ width: '400px', margin: '0 auto 24px auto' }} {...formItemLayout} label="旧密码">
                        {getFieldDecorator('oldPassWord', {
                            rules: [{ required: true, message: '请填写旧密码!' }],
                        })(<Input placeholder="请输入旧密码" type="password" htmlType="password" />)}
                    </FormItem>
                </Row>
                <Row style={{ textAlign: 'center' }}>
                    <FormItem style={{ width: '400px', margin: '0 auto 24px auto' }} {...formItemLayout} label="新密码">
                        {getFieldDecorator('newPassWord', {
                            rules: [{ required: true, whitespace: true, pattern: /^(^(?![^A-Z]+$)(?![^a-z]+$)(?!\D+$))\w{8,100}$/, message: '请填写新密码,不少于8位大小写字母加数字!' }],
                        })(<Input placeholder="请输入新密码" type="password"  htmlType="password" />)}
                    </FormItem>
                </Row>

                <div style={{ textAlign: 'center' }}>
                    <Button type="primary" onClick={() => this.modifyUser()}>
                        确定
                    </Button>
                </div>
            </Form>
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
    modifySelf: value => dispatch(modifySelf(value)), // 新增用户
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Edit));



// WEBPACK FOOTER //
// ./components/sider/useredit.js